import { StoreContext } from '../../../lib/store';
import { useContext } from 'react';

import * as React from 'react';
import { Cta } from 'common/components/cta';

export function Component() {
  const store = useContext(StoreContext);

  const { cta } = store.formatConfig;

  const isVertical = store.creativeStore.isVertical;

  return (
    <>
      {!isVertical && (
        <Cta {...cta} onClick={e => store.userClickHandler.handle(e)} />
      )}
    </>
  );
}
